<script lang="ts" setup>
	import FormElementWrapper from '@/views/components/form-elements/partials/form-element-wrapper.vue';
	import {
		FormElementEmail,
		FormElementPassword,
		FormElementText,
		FormElementUrl,
	} from '@/scripts/types/generated';
	import {FormField} from '@/components/ui/form';

	const $props = withDefaults(
		defineProps<
			Partial<
				| FormElementText
				| FormElementUrl
				| FormElementEmail
				| FormElementPassword
			>
		>(),
		{
			type: 'text',
			category: 'field',
		}
	);

	const $emit = defineEmits<{
		change: [event: Event];
	}>();
</script>

<template>
	<FormField
		v-slot="{componentField}"
		:name="$props.name"
	>
		<FormElementWrapper v-bind="{...$attrs, ...$props}">
			<FormControl>
				<Input
					:placeholder="$props.placeholder"
					:readonly="$props.readonly"
					:type="$props.type"
					v-bind="{...componentField, ...$attrs}"
					@change="$emit('change', $event)"
				/>
			</FormControl>
		</FormElementWrapper>
	</FormField>
</template>
